export default "__VITE_ASSET__JlcX0Tat__"